




















































































































































































































































































































































































import { TranslatedCountryDTO } from "@/model/component.model";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { required, requiredIf } from "vuelidate/lib/validators";
import Accordion from "../../shared/Accordion.vue";
import { AddressShipmentDTO, SubcountryDTO } from "@/model/data.model";
import isPhone from "../../../definitions/telephone-validator";
import store from "@/vuex/store";
import addressDisplay from "@/filters/AddressFilter";
import { emailValidator } from "../../../definitions/email-validator";
import provinceValidator from "../../../definitions/province-validator";

@Component({
  components: {
    Accordion: Accordion
  },
  validations() {
    return {
      address: {
        address: { required },
        companyName: { required },
        zipCode: { required },
        city: { required },
        countryName: { required },
        subcountry: { required },
        contact: {
          required: requiredIf(function(this: AddressAutocomplete) {
            return this.$store.getters["customer/info"].tenantId !== 3;
          })
        },
        phone: { isPhone },
        secondPhone: { isPhone },
        email: {
          emailValidator,
          required: requiredIf(() => this.$props.isEmailRequiredNew)
        },
        secondEmail: { emailValidator },
        province: {
          validator: provinceValidator(this.$props.address.countryName)
        }
      }
    };
  }
})
export default class AddressAutocomplete extends Vue {
  @Prop() address: AddressShipmentDTO;
  @Prop() edition: boolean;
  @Prop() isEmailRequiredNew: boolean;
  @Prop() countries: TranslatedCountryDTO[];
  @Prop() showAddressButtons: boolean;
  trimAddress() {
    AddressShipmentDTO.trimStrings(this.address);
  }
  subcountries: SubcountryDTO[] = [];

  dataSource: any = "fromUser";
  created() {
    this.$parent.$on("changeAddressToFromUser", () => {
      this.$emit("changeAddressTo", "fromUser");
      this.dataSource = "fromUser";
    });
    if (this.$route.params.id === undefined) {
      this.setDataFrom("fromUser");
    }
    setTimeout(() => {
      this.loadSubcountries();
    }, 1000);
  }

  @Watch("address")
  addressHasBeenUpdated(newAddress) {
    //console.log(newAddress);
  }

  get translatedName(): string {
    return this.countries.find(item => item.id == this.address.countryId)
      ? this.countries.find(item => item.id == this.address.countryId)
          .translatedName
      : "";
  }

  setDataFrom(type) {
    this.$emit("changeAddressTo", type);
  }

  senderAsString(): string {
    let s = this.address.companyName ? `${this.address.companyName} - ` : "";
    const addrText = addressDisplay(this.address);
    if (addrText) {
      s += addrText;
    }
    return s;
  }

  @Watch("address.countryId", {
    deep: true
  })
  forceReload() {
    this.loadSubcountries();
  }

  loadSubcountries(): Promise<any> {
    if (this.address.countryId) {
      const storeZipCode = this.$store.getters["customer/storeAddresses"][0]
        .zipCode;
      const storeIsoCode = this.$store.getters["customer/storeAddresses"][0]
        .countryId;
      return store.cache
        .dispatch(
          "cachemod/getSubcountries",
          {
            countryId: this.address.countryId,
            zipcode: this.address.zipCode,
            storeZipCode: storeZipCode,
            storeIsoCode: storeIsoCode
          },
          { timeout: store.state["cachemod"].timeouts.subCountries }
        )
        .then((res: SubcountryDTO[]) => {
          if (res !== undefined) {
            this.subcountries = res;
            if (this.subcountries.length === 1) {
              this.address.subcountry = this.subcountries[0].description;
              this.address.subcountryId = this.subcountries[0].idSubcountry;
              this.address.cee = this.subcountries[0].cee;
              this.$emit("updateCeeAddressFor", this.subcountries[0].cee);
            }
          } else {
            if (this.subcountries.length > 0) {
              this.subcountries = [];
            }
          }
        })
        .catch(() =>
          this.$snotify.error(this.$t("error_getting_subcountries").toString())
        );
    } else {
      return Promise.resolve(null);
    }
  }
  get isEmpty() {
    if (
      this.$t("phone_warning") === "phone_warning" ||
      this.$t("phone_warning") === ""
    ) {
      return true;
    }
    return false;
  }
}
